// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ProductSliders_wrapper__GeUpw","slider":"ProductSliders_slider__c44mi","horizontal":"ProductSliders_horizontal__ofoZo","vertical":"ProductSliders_vertical__HpSaY"};